import { Fragment, useEffect, useState } from "react";
import useHttp from "../hooks/use-http";
import { getStock } from "../lib/api";
import StockChart from "./StockChart";
import { MOCK_STOCKS } from '../data/mockStockData';


const Stocks = () => {

    const { sendRequest, status, data: loadedStocks, error } = useHttp(getStock, false);
    const [inputError, setInputError] = useState(null);
       const [ticker, setTicker] = useState('');

    useEffect(() => {
          // Only fetch on mount if we have a valid default ticker
        if (ticker) {
            console.log("Fetching stock data for ticker:", ticker);
            sendRequest(ticker);
        }
    }, [ticker]);

   

  const displayData = loadedStocks && loadedStocks.length > 0 ? loadedStocks : MOCK_STOCKS;




const handleSubmit = (event) => {
    event.preventDefault(); // Prevents page reload
    const inputField = event.target.elements.tickerInput;
    const finalValue = inputField.value.toUpperCase().trim();
    
    if (!finalValue) {
        setInputError('Ticker is required.');
        return;
    }

    setInputError(null);
    setTicker(finalValue);
    sendRequest(finalValue);
};



      
   //console.table(loadedStocks);
    return (<Fragment>
      
<form onSubmit={handleSubmit} className="flex flex-col gap-2 mb-6">
    <div className="flex gap-2">
      <input 
        name="tickerInput" 
        defaultValue={ticker} 
        className="uppercase border p-2 rounded" 
        placeholder="e.g. AAPL"
      />
      <button 
        type="submit" 
        className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
      >
        Update Chart
      </button>
    </div>
    {inputError && <p className="text-red-500 text-xs">{inputError}</p>}





  </form>


            {status === 'pending' && <p>Loading...</p>}

            {error && <p className="text-red-500">{error}</p>}

            {status === 'error' && (!loadedStocks || loadedStocks.length === 0) && (
                <div className="bg-amber-50 p-4 border border-amber-200 rounded">
                    An error occurred or the app reached API limit. Please wait for 1 minute and try again.
                </div>
            )}

            {/* 3. The Chart only shows when data is ready */}
            {displayData && displayData.length > 0 && (
                <StockChart data={displayData} width={700} height={300} />
            )}




    </Fragment>
    )
}

export default Stocks;